import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";


export default function AdminMonthlySalarySettlement() {
  const [deliveryBoys, setDeliveryBoys] = useState([]);
  const [selectedBoy, setSelectedBoy] = useState("");
  const [pending, setPending] = useState(0);
   const [baseSalary, setBaseSalary] = useState(0);
  const [totalReceived, setTotalReceived] = useState(0);

  // YYYY-MM format
  const [month, setMonth] = useState(
    new Date().toISOString().slice(0, 7)
  );

  const [deliveryIncome, setDeliveryIncome] = useState(0);
  const [salary, setSalary] = useState("");
  const [topup, setTopup] = useState("");
  const [note, setNote] = useState("");

  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------------- LOAD DELIVERY BOYS ---------------- */
  useEffect(() => {
    loadDeliveryBoys();
  }, []);

  /* ---------------- LOAD INCOME + HISTORY ---------------- */
useEffect(() => {
  if (selectedBoy && month) {
    loadDeliveryIncome();
    loadHistory();
  }
}, [selectedBoy, month]);

useEffect(() => {
  if (selectedBoy) {
    
    loadHistory();
  }
}, [selectedBoy]);



useEffect(() => {
  if (selectedBoy) {
    loadPaymentSummary();
    loadBaseSalary();
  }
}, [selectedBoy]);


  /* ---------------- API CALLS ---------------- */

  const loadDeliveryBoys = async () => {
    try {
      const res = await axios.get("/admin/delivery-boys/");
      setDeliveryBoys(res.data.delivery_boys || []);
    } catch (err) {
      console.error("Failed to load delivery boys", err);
    }
  };

  // 🔥 SIMPLE + RELIABLE INCOME API (NO MONTH LOGIC)
const loadDeliveryIncome = async () => {
  const res = await axios.get(
    `/admin/monthly-delivery-income/?delivery_boy_id=${selectedBoy}&month=${month}`
  );
  setDeliveryIncome(res.data.delivery_income || 0);
};


const loadHistory = async () => {
  try {
    const res = await axios.get(
      `/admin/monthly-salary-history/?delivery_boy_id=${selectedBoy}`
    );

    setHistory(res.data.monthly_salary || []);
  } catch (err) {
    console.error("Failed to load salary history", err);
    setHistory([]);
  }
};

const loadPaymentSummary = async () => {
  try {
    const res = await axios.get(
      `/admin/delivery/payment-summary/?delivery_boy_id=${selectedBoy}`
    );

    setPending(res.data.pending_amount || 0);
    setTotalReceived(res.data.total_received || 0);

  } catch (err) {
    console.error("Failed to load payment summary", err);
    setPending(0);
    setTotalReceived(0);
  }
};

const loadBaseSalary = async () => {
  try {
    const res = await axios.get(
      `/admin/base-salary-history/?delivery_boy_id=${selectedBoy}`
    );

    const history = res.data.base_salary_history || [];

    // latest record (because backend orders by -month)
    setBaseSalary(history[0]?.base_salary || 0);
  } catch (err) {
    console.error("Failed to load base salary", err);
    setBaseSalary(0);
  }
};

  /* ---------------- SAVE MONTHLY SALARY ---------------- */
  const handleSave = async () => {
    if (!selectedBoy || !month) {
      alert("Select delivery boy and month");
      return;
    }

    setLoading(true);
    try {
      await axios.post("/admin/set-monthly-payout/", {
        delivery_boy_id: selectedBoy,
        month,
        salary_amount: salary || 0,
        topup_amount: topup || 0,
        admin_note: note,
      });

      alert("Monthly salary saved");

      // reset inputs
      setSalary("");
      setTopup("");
      setNote("");

      // 🔥 IMPORTANT: reload both
      await loadHistory();
      await loadDeliveryIncome();

    } catch (err) {
      alert(err.response?.data?.error || "Failed to save monthly salary");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={page}>
      <h2 style={{ marginBottom: 16 }}>📅 Monthly Salary Settlement</h2>

      {/* ---------------- FORM ---------------- */}
      <div style={card}>
        <div style={row}>
          <select
            value={selectedBoy}
            onChange={(e) => setSelectedBoy(e.target.value)}
            style={input}
          >
            <option value="">Select Delivery Boy</option>
            {deliveryBoys.map((b) => (
              <option key={b.id} value={b.id}>
                {b.name} ({b.phone})
              </option>
            ))}
          </select>

          <input
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            style={input}
          />
        </div>

{/* Delivery Income + Pending + Base Salary + Total Received */}
<div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
  <div style={{ flex: 1 }}>
    <input
      type="text"
      value={`₹ ${deliveryIncome}`}
      readOnly
      style={{ ...input, background: "#f8fafc", fontWeight: "bold" }}
    />
    <small>Delivery income</small>
  </div>

  <div style={{ flex: 1 }}>
    <input
      type="text"
      value={`₹ ${pending}`}
      readOnly
      style={{
        ...input,
        background: "#fff7ed",
        border: "1px solid #f59e0b",
        fontWeight: "bold",
      }}
    />
    <small>Pending amount</small>
  </div>

  <div style={{ flex: 1 }}>
    <input
      type="text"
      value={`₹ ${baseSalary}`}
      readOnly
      style={{
        ...input,
        background: "#ecfeff",
        border: "1px solid #06b6d4",
        fontWeight: "bold",
      }}
    />
    <small>Base salary</small>
  </div>

  <div style={{ flex: 1 }}>
    <input
      type="text"
      value={`₹ ${totalReceived}`}
      readOnly
      style={{
        ...input,
        background: "#f0fdf4",
        border: "1px solid #22c55e",
        fontWeight: "bold",
      }}
    />
    <small>Total received</small>
  </div>
</div>



        <div style={row}>
          <input
            type="number"
            placeholder="Salary (fixed)"
            value={salary}
            onChange={(e) => setSalary(e.target.value)}
            style={input}
          />

          <input
            type="number"
            placeholder="Top-up (optional)"
            value={topup}
            onChange={(e) => setTopup(e.target.value)}
            style={input}
          />
        </div>

        <textarea
          placeholder="Admin note (optional)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          style={textarea}
        />

        <button onClick={handleSave} style={button} disabled={loading}>
          {loading ? "Saving..." : "Save Monthly Salary"}
        </button>
      </div>

      {/* ---------------- HISTORY ---------------- */}
      <h3 style={{ marginTop: 30 }}>📜 Monthly Salary History</h3>

      <div style={card}>
        {history.length === 0 ? (
          <p>No records found</p>
        ) : (
          <table style={table}>
            <thead>
              <tr>
                <th>Month</th>
                <th>Pending Amount</th>
                <th>Salary</th>
                <th>Top-up</th>
                <th>Total Paid</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody>
              {history.map((h, i) => (
                <tr key={i}>
                  <td>{h.month}</td>
        <td>₹{pending}</td>
<td>₹{h.salary_amount ?? h.salary ?? 0}</td>
<td>₹{h.topup_amount ?? h.top_up ?? 0}</td>
<td>₹{h.total_paid ?? h.total ?? 0}</td>
<td>{h.admin_note || "-"}</td>


                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

/* ---------------- STYLES ---------------- */

const page = { padding: 24, background: "#f1f5f9", minHeight: "100vh" };

const card = {
  background: "#fff",
  padding: 20,
  borderRadius: 12,
  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
  marginBottom: 16,
};

const row = {
  display: "flex",
  gap: 12,
  marginBottom: 12,
};

const input = {
  flex: 1,
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #cbd5e1",
};

const textarea = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #cbd5e1",
  minHeight: 80,
  marginBottom: 12,
};

const button = {
  background: "#2563eb",
  color: "#fff",
  border: "none",
  padding: "10px 16px",
  borderRadius: 8,
  cursor: "pointer",
};

const table = {
  width: "100%",
  borderCollapse: "collapse",
};
